<script setup lang="ts">
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})
</script>

<template>
  <StrapiSlice
    v-if="slice?.EmbedCode"
    class="ct-embed"
    :class="{ 'ct-embed--padding': slice.Padding }"
    :slice="slice"
    :index="index"
  >
    <UiEmbed :embed-code="slice.EmbedCode" />
  </StrapiSlice>
</template>

<style>
@import url("~layers/components/Strapi/Slice.css");
@import url("~layers/components/Slices/Embed.css");
</style>
